'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--LastfmWithCircle';

var EntypoLastfmWithCircle = function EntypoLastfmWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M12.644,12.83c-2.002,0-2.697-0.91-3.066-2.043L9.207,9.621C8.93,8.77,8.706,8.154,7.688,8.154c-0.706,0-1.626,0.463-1.626,1.898c0,1.119,0.77,1.82,1.568,1.82c0.677,0,1.084-0.381,1.296-0.572l0.354,1.012c-0.241,0.174-0.734,0.517-1.707,0.517c-1.346,0-2.625-0.957-2.625-2.73c0-1.844,1.333-2.93,2.705-2.93c1.54,0,2.113,0.56,2.6,2.078l0.382,1.166c0.278,0.852,0.865,1.471,2.034,1.471c0.787,0,1.204-0.176,1.204-0.607c0-0.338-0.197-0.584-0.787-0.723l-0.787-0.188c-0.961-0.232-1.343-0.734-1.343-1.529c0-1.271,1.018-1.668,2.061-1.668c1.181,0,1.898,0.432,1.99,1.482l-1.157,0.139c-0.046-0.5-0.347-0.711-0.903-0.711c-0.509,0-0.821,0.234-0.821,0.631c0,0.35,0.15,0.559,0.66,0.676l0.74,0.164c0.995,0.233,1.528,0.723,1.528,1.668C15.053,12.387,14.08,12.83,12.644,12.83z' })
    );
};

exports.default = EntypoLastfmWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/LastfmWithCircle.js
// module id = 641
// module chunks = 168707334958949